"use strict";
var promise1 = new Promise(function(resolve) {
    document.querySelector(".logo").addEventListener("click", resolve);
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(reject, 3000);
});
var onSuccess = function() {
    var div = document.createElement("div");
    div.className = "message";
    div.textContent = "Promise was resolved!";
    document.body.appendChild(div);
};
var onError = function() {
    var div = document.createElement("div");
    div.className = "message error-message";
    div.textContent = "Promise was rejected!";
    document.body.appendChild(div);
};
promise1.then(onSuccess, onError);
promise2.then(onSuccess, onError);

//# sourceMappingURL=index.894ecf6f.js.map
